var React = require( 'react' );
var createReactClass = require('create-react-class');
var marked = require('marked');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var ContentMarkDown = createReactClass( {
	mixins: [PureRenderMixin],
	rawMarkup: function() {
	    var rawMarkup = marked(this.props.payload.toString(), {sanitize: true});
	    return { __html: rawMarkup };
	},

	render: function () {

		// console.log("MARKDOWN:" + JSON.stringify(this.props));
		return (<span dangerouslySetInnerHTML={this.rawMarkup()}/>);
	}
});

module.exports = ContentMarkDown;


// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/contentMarkDown.jsx